import { FC, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { baseNavTabs } from 'constants/navConstants';
import { NavTab } from 'types/baseTypes';
import TeamSwitcher from './components/TeamSwitcher';
import { findActiveTab } from 'utils/commonUtils';
import NavSection from './components/NavSection';
import classNames from 'classnames';
import classnames from 'classnames';
import { twMerge } from 'tailwind-merge';
import { disableHoverState, enableHoverState, selectMenuState } from 'containers/app/appSlice';
import { useDispatch } from 'react-redux';
import { useAppSelector, useScreenDimensions } from 'hooks';
import { logAnalyticEvent } from 'utils/analytics';
import { useGetSideNavList } from './useGetSideNavList';
import { shouldShowFSMModal } from 'containers/subscriptions/utils';

const SideNav: FC = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const isMenuActive = useAppSelector(selectMenuState);
  const showSubscriptionModal = shouldShowFSMModal(location.pathname) ?? false;

  const { screenWidth } = useScreenDimensions();

  const [activeTab, setActiveTab] = useState(findActiveTab(location?.pathname) ?? baseNavTabs[0]);
  const [isTeamSwitcherOpen, setIsTeamSwitcherOpen] = useState(false);

  const navSectionList = useGetSideNavList();

  useEffect(() => {
    setActiveTab(findActiveTab(location?.pathname) ?? baseNavTabs[0]);
  }, [location]);

  const onTabClick = (tab: NavTab) => {
    setActiveTab(tab);
    navigate(tab.path);
    if (tab.clevertapEvent) {
      logAnalyticEvent(tab.clevertapEvent);
    }
  };

  const onSubTabClick = (tab: NavTab) => {
    navigate(tab.path);
    if (tab.clevertapEvent) {
      logAnalyticEvent(tab.clevertapEvent);
    }
  };

  const lastIndex = navSectionList.length - 1;

  const handleMouseEnter = () => {
    if (isMenuActive && screenWidth < 1024) {
      return;
    }
    if (isTeamSwitcherOpen) {
      return;
    }
    dispatch(enableHoverState());
  };

  const handleMouseLeave = () => {
    if (isMenuActive && screenWidth < 1024) {
      return;
    }
    dispatch(disableHoverState());
  };

  const urlRoute = location.pathname;

  if (urlRoute === '/banking-onboarding') {
    return null;
  }

  return (
    <div
      className={twMerge(
        `customNormalScroll bg-primary hidden flex-col overflow-auto border-r w-[100px]
        text-sbase sm:flex ${!isMenuActive ? 'h-[calc(100%_-_60px)]' : ''}
        ${showSubscriptionModal ? 'z-[51]' : 'z-[49]'}`,
        classNames({
          'min-w-[255px]': isMenuActive,
          'hover:fixed md:hover:w-[235px]  transition-[width] fixed': !isMenuActive
        })
      )}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}>
      <div className="overflow-y-auto overflow-x-hidden">
        {navSectionList.map((navList, index) => {
          return (
            <NavSection
              className={twMerge(
                'mx-3',
                classnames({
                  'border-b border-secondaryBtn': index !== lastIndex
                })
              )}
              key={navList.toString() + navList[0].key}
              activeTab={activeTab}
              navList={navList}
              onNavTabClick={onTabClick}
              onSubTabClick={onSubTabClick}
            />
          );
        })}
      </div>
      <TeamSwitcher
        showDetails={true}
        className="mt-auto h-[80px] min-h-[80px] overflow-hidden border-t border-borderGray pl-4 pr-3"
        onStartTeamSwitch={() => setIsTeamSwitcherOpen(true)}
        onTeamSwitchClose={() => setIsTeamSwitcherOpen(false)}
      />
    </div>
  );
};

export default SideNav;
